import Box from '@mui/material/Box';

export function Footer() {
  return (
    <Box textAlign="center">
      Copyright © Pandlr 2015 - 2022.
    </Box>
  );
}
